import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useAppSelector } from '../../../app/store';
import { UPLOAD_PENDING, UPLOAD_IN_PROGRESS, UPLOAD_COMPLETED, UPLOAD_FAILED } from '../../../settings';
import { ADMIN_LANG } from '../../../settings';

const PdfProcessingProgress = () => {
    const { isProcessing, processingStatus, currentPage, totalPages } = useAppSelector(
        (state) => state.sectionPdfModal
    );

    if (!isProcessing) {
        return null;
    }

    const getStatusVariant = () => {
        switch (processingStatus) {
            case UPLOAD_PENDING:
                return 'info';
            case UPLOAD_IN_PROGRESS:
                return 'primary';
            case UPLOAD_COMPLETED:
                return 'success';
            case UPLOAD_FAILED:
                return 'danger';
            default:
                return 'secondary';
        }
    };

    const getStatusText = () => {
        switch (processingStatus) {
            case UPLOAD_PENDING:
                return ADMIN_LANG.pdf_processing_pending;
            case UPLOAD_IN_PROGRESS:
                return `${ADMIN_LANG.pdf_processing_in_progress} (${ADMIN_LANG.pdf_page} ${currentPage}/${totalPages})`;
            case UPLOAD_COMPLETED:
                return ADMIN_LANG.pdf_processing_completed;
            case UPLOAD_FAILED:
                return ADMIN_LANG.pdf_processing_failed;
            default:
                return '';
        }
    };

    const progress = totalPages ? Math.round((currentPage || 0) / totalPages * 100) : 0;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <span>{getStatusText()}</span>
                <span>{progress}%</span>
            </div>
            <ProgressBar
                variant={getStatusVariant()}
                now={progress}
                animated={processingStatus === UPLOAD_IN_PROGRESS}
            />
        </div>
    );
};

export default PdfProcessingProgress;